var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-card");
/**
 * This component is used to dynamically add addons to the `CardHeader`
 * component. When no children are provided, nothing will be rendered.
 *
 * @internal
 */
export function CardHeaderAddon(_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    if (!children) {
        return null;
    }
    return (_jsx("span", __assign({}, props, { className: cn(block("header-addon"), className) }, { children: children })));
}
//# sourceMappingURL=CardHeaderAddon.js.map